import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconCaretDown = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#5f6567"} className={`caret-down ${props.className}`} viewBox="0 0 500 500">
       <path d="M0 140.6c0-8.5 3.1-15.8 9.3-22s13.5-9.3 22-9.3h437.5c8.5 0 15.8 3.1 22 9.3 6.2 6.2 9.3 13.5 9.3 22s-3.1 15.8-9.3 22L272 381.3c-6.2 6.2-13.5 9.3-22 9.3s-15.8-3.1-22-9.3L9.3 162.6c-6.2-6.2-9.3-13.5-9.3-22z"></path>
    </IconWrapper>
);

export default memo(IconCaretDown);
